<template>
  <div class="reward">
    <router-link tag="div" to="./withdraw" class="btn-withdraw">
      <a>{{$t(langKey+'.button1')}}</a>
    </router-link>
    <div class="balance">
      <div>
        <span>{{$t(langKey+'.title')}}</span>
        <div><span v-if="lang==='zh'">¥</span><span v-else>$</span>{{summary.balance}}</div>
      </div>
    </div>
    <div class="summary">
      <div>
        <div class="row1">
          <div>
            <span>{{summary.submit_opinion_count}}</span>
          </div>
          <div>
            <span>{{summary.accepted_opinion_count}}</span>
          </div>
          <div>
            <span><i v-if="lang==='zh'">¥</i><i v-else>$</i>{{summary.total_reward}}</span>
          </div>
        </div>
        <div class="row2">
          <div>
            <div>{{$t(langKey+'.summary1')}}</div>
          </div>
          <div>
            <div>{{$t(langKey+'.summary2')}}</div>
          </div>
          <div>
            <div>{{$t(langKey+'.summary3')}}</div>
          </div>
        </div>
      </div>
    </div>
    <div class="items">
      <router-link tag="div" to="./reward-list" class="item">
        <div class="left">
          <i class="srmx"></i>{{$t(langKey+'.item1')}}
        </div>
        <div class="right"><span v-if="lang==='zh'">查看</span><i class="iconfont icon-right"></i></div>
      </router-link>
      <router-link tag="div" to="./account" class="item">
        <div class="left">
          <i class="txzh"></i>{{$t(langKey+'.item2')}}
        </div>
        <div class="right"><span v-if="lang==='zh'">查看</span><i class="iconfont icon-right"></i></div>
      </router-link>
    </div>
  </div>
</template>
<script type="text/ecmascript-6">
import { setTitle } from 'components/mixin/title'
import { getRewards } from 'api/me'
import { mapGetters } from 'vuex'
import { MessageBox } from 'mint-ui'
export default {
  data() {
    return {
      langKey: this.$route.name,
      summary: {}
    }
  },
  computed: {
    ...mapGetters(['lang', 'userInfo', 'isAbroad'])
  },
  mixins: [setTitle],
  created() {
    // 有联系方式才发送请求
    if (this.userInfo.mobile || this.userInfo.email) {
      this._getRewards()
    }
  },
  methods: {
    _getRewards() {
      // 判断是不是国外, 如果是国外, 获取email, 否则获取mobile
      let contact = this.isAbroad ? this.userInfo.email : this.userInfo.mobile
      this.$loading.open()
      getRewards(contact).then(res => {
        console.log(res)
        this.summary = res.data
        this.$loading.close()
      }).catch(err => {
        console.error(err)
        MessageBox.alert(err.msg)
        this.$loading.close()
      })
    }
  },
  watch: {
    userInfo(nv) {
      this._getRewards()
    }
  },
  beforeDestroy() {
    this.$loading.close()
  }
}
</script>
<style scoped lang="scss">
  @import "css/def";
  .reward{
    min-height: 100vh;
    background:rgba(241,241,241,1);
    >.btn-withdraw{
      position: absolute;
      top: size(30);
      right: 0;
      height: size(58);
      line-height: size(58);
      width: size(130);
      background-color: #D9251D;
      text-align: center;
      color: #fff;
      padding-left: size(20);
      border-radius: size(29) 0 0 size(29);
      font-size: size(26);
      z-index: 99;
      a{
        color: #fff;
      }
    }
    >.balance{
      @include border('bottom');
      width: 100%;
      height: size(250);
      @include flex();
      background-color: #fff;
      >div{
        text-align: center;
        width: 100%;
        >span{
          color: #333;
          font-size: size(26);
          font-weight: 600;
        }
        >div{
          color: #D9251D;
          font-size: size(80);
          margin-top: size(26);
          span{
            font-size: size(26);
          }
        }
      }
    }
    >.summary{
      width: 100%;
      height: size(190);
      background-color: #fff;
      color: #333;
      text-align: center;
      @include flex();
      align-items: center;
      >div{
        width: 100%;
        >div{
          width: 100%;
          @include flex();
          >div{
            width: 33.33333%;
            font-size: size(26);
            >span{
              font-size: size(40);
              i{
                font-style: normal;
                font-size: size(24);
              }
            }
          }
          &.row1{
            height: size(40);
          }
          &.row2{
            align-items: flex-start;
            margin-top: size(20);
          }
        }
      }
    }
    >.items{
      margin-top: size(20);
      background-color: #fff;
      >.item{
        @include flex();
        justify-content: space-between;
        padding: 0 size(32);
        height: size(112);
        @include border('bottom');
        .left{
          font-size: size(30);
          color: #333;
          i{
            display: inline-block;
            width: size(40);
            height: size(40);
            -webkit-background-size: 100% 100%;
            background-size: 100% 100%;
            background-repeat: no-repeat;
            vertical-align: bottom;
            margin-right: size(20);
            position: relative;
            bottom: -1px;
            &.srmx{
              background-image: url('~image/icon/srmx.png');
            }
            &.txzh{
              background-image: url('~image/icon/txzh.png');
            }
          }
        }
        .right{
          font-size: size(26);
          color: #999;
          i{
            margin-left: size(14);
            font-size: size(32);
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/me/reward.vue